export function camelize(text: string): string {
  text = text.replace(/[-_\s.]+(.)?/g, (_, c: string | undefined | null) =>
    c ? c.toUpperCase() : ''
  )
  return text.substring(0, 1).toLowerCase() + text.substring(1)
}
